import * as types from '../constants/outstandingOrderConstants';
import * as activityConstants from '../constants/activityConstants';
import appConstants from '../appConstants';
import moment from 'moment';
import config from './../config.js';
const initialState = {
  bmList:[],
  lmtModifyFlag:false,
  opnTrdModifyFlag:false,
  opnTrdAllctFlag:false,
  physicalsRecord:[],
  fixModifyFlag:false,
  showOpenTradeAlert:false,
  openTradeMsg: {
    errorMessage:'',
    isWidgetRefresh: false
  }
};
const getPhysicalRecord = (instrumentList) => {
  var srNo=0;
  return instrumentList.map((item,index) => {
    item.selectedQty =0;
    item.docNo=item.docno;
    item.DocSrNo=item.docsrno;
    item.gq=(Number(parseFloat(item.bal_pur_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
    srNo++;
    return {
      ...item,
      docNo:  item.docno,
      selectedQty:0,
      DocSrNo:item.docsrno,
      gq:(Number(parseFloat(item.bal_pur_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      srNo:srNo
    };
  });
};
//get message - open trade invalid qty 
const getMessage = (status,openTradeMsg,) =>{
  let textmsg= '';
  let flag=false;
  if(status)
switch (parseFloat(status)) {
    	case 141:
        textmsg="alreadySquaredOff";//"This Fixing Document has been already Squared off/Allocated.";
        flag= true;
      break
      case 142:
        textmsg="quantityChange"//"The pending quantity for the Fixing Document has changed." ;
        flag= true;
      break
      case 117:
        textmsg="anotherTrdExecute";//"Another trader is executing in this account. Please try again later.";
        flag= false;// not refresh open trade wigdet
      break;
      default:
        textmsg = ""
        flag=false
      };
      openTradeMsg.errorMessage=textmsg;
      openTradeMsg.isWidgetRefresh=flag;
  return openTradeMsg;
}


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
      case types.LOAD_OUTSTANDING_ORDER:
      return {
          ...state,
          };
      case types.LOAD_OUTSTANDING_ORDER_SUCCESS:

        return {
          ...state,
           };
      case types.LOAD_OUTSTANDING_ORDER_FAILURE:
        return {
          ...state,
        };
      case types.GET_ALL_BM:
        return{
          ...state,
        };
      case types.GET_ALL_BM_SUCCESS:
        return{
          ...state,
          bmList:action.result.data
        };
      case types.GET_ALL_BM_FAILURE:
        return{
          ...state,
        };
      case types.LOAD_LMTMODIFYPOPUP_FLAG:
      localStorage.setItem('lmtModifyFlag',action.flag);
      return {
        ...state,
        lmtModifyFlag: action.flag
      };
      case types.LOAD_OPENTRADEMODIFYPOPUP_FLAG:
      localStorage.setItem('opnTrdModifyFlag',action.flag);
      return {
        ...state,
        opnTrdModifyFlag: action.flag
      };
      case activityConstants.LOAD_OPENTRADEALLOCATE_FLAG:
      localStorage.setItem('opnTrdAllctFlag',action.flag);
      return {
        ...state,
        opnTrdAllctFlag: action.flag
      };
      case types.ALLOCATE_QUANTITY:
        return{
          ...state,
        };
      case types.ALLOCATE_QUANTITY_SUCCESS:
        return{
          ...state,
        };
      case types.ALLOCATE_QUANTITY_FAILURE:
        return{
          ...state,
          showOpenTradeAlert:true,
          openTradeMsg:getMessage(action.result.errCode,state.openTradeMsg)
        };
      case types.GET_PHYSICALS:
        return{
          ...state,
        };
      case types.GET_PHYSICALS_SUCCESS:
        return{
          ...state,
          physicalsRecord:getPhysicalRecord(action.result.dataObject)
        };
      case types.GET_PHYSICALS_FAILURE:
        return{
          ...state,
        };
      case types.LOAD_FIXMODIFYPOPUP_FLAG:
      localStorage.setItem('fixModifyFlag',action.flag);
      return {
          ...state,
          fixModifyFlag: action.flag
      };
      case activityConstants.SHOW_OPENTRADE_ALERT:
        let status=(action.message === 'closePopup'? '' : action.message.STATUS)
        return{
          ...state,
          showOpenTradeAlert:action.flag,
          openTradeMsg:getMessage(status,state.openTradeMsg)
        }

      default:
        return state;
  }
}
